import React from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Typography,
} from "@mui/material";
import { UseDashboardContext } from "src/context/dashboard";
import useStyles from "./Styles";

const GlobalTimeFrameFilter: React.FC = () => {
  const { classes } = useStyles();
  const contextData = UseDashboardContext();

  if (!contextData) return null;
  const { globalTimeFrame, setGlobalTimeFrame } = contextData;

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newTimeFrame: string | null,
  ) => {
    if (newTimeFrame !== null) {
      setGlobalTimeFrame(newTimeFrame);
    }
  };

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>Stats Overview</Typography>
      <ToggleButtonGroup
        value={globalTimeFrame}
        exclusive
        onChange={handleAlignment}
        aria-label="timeframe"
        className={classes.toggleGroup}
      >
        <ToggleButton value="today" aria-label="today">
          Today
        </ToggleButton>
        <ToggleButton value="yesterday" aria-label="yesterday">
          Yesterday
        </ToggleButton>
        <ToggleButton value="lastWeek" aria-label="last week">
          Last Week
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default GlobalTimeFrameFilter;
